import type { Partner } from "@expert/shared-types";

import { useQuery } from "@tanstack/react-query";

import { getCallIntroFlowQuestions } from "../api/getCallIntroFlowQuestions";
import { useContentfulClient } from "../ContentfulClientProvider";

export interface UseCallIntroFlowQuestionsOptions {
    /** Whether the query should be enabled. Defaults to true. */
    enabled?: boolean;
}

export const useCallIntroFlowQuestions = (partner: Partner, options?: UseCallIntroFlowQuestionsOptions) => {
    const contentfulClient = useContentfulClient();
    const { data, error } = useQuery({
        queryKey: ["call-intro-flow-questions", partner],
        queryFn: async () => await getCallIntroFlowQuestions(contentfulClient, partner),
        enabled: options?.enabled ?? true,
    });

    if (error) return undefined;

    // Convert React Query null to undefined for consistency with existing type expectations
    return data ?? undefined;
};
